import Table from "Shared/components/DataTable/Table"
import restClient from 'Shared/hooks/restClient'
import PinnedBookmarks from "Shared/components/PinnedBookmarks/PinnedBookmarks"

const FlowsDatatable = ({ tableType, ballots }) => {
  const section = ballots ? 'ballots' : 'pages'

  const handleTableClick = (e) => {
    const button = e.target.closest('button')
    if (button && button.classList.contains('toggle-bookmark')) {
      restClient
        .post('/api/user_bookmarks/toggle', { entity_type: 'Flow', entity_id: button.dataset.id })
        .then(() => {
          window.dispatchEvent(new CustomEvent('bookmarks-changed', { detail: { entityType: 'Flow', section } }))
        })
      return
    }
    if (button && button.classList.contains('restore-flow')) {
      const flowId = button.dataset.flowId

      if (window.confirm('Are you sure you want to restore this page?')) {
        restClient.post(`/api/flows/${flowId}/restore`).then(() => {
          window.location.href = ballots ? '/admin/ballots' : '/admin/flows'
        })
      }
    }
  }

  const emptyTableMessage = ballots && tableType === 'all' ? "You've not set up any ballots yet." :
    ballots && tableType === 'archived' ? "You have no archived ballots." :
    tableType === 'all' ? "You've not set up any pages yet." :
    "You have no archived pages."

  const tableProps = {
    table: 'flows',
    scope: { section },
    language: { emptyTable: emptyTableMessage },
    includeTypeParam: true,
    onClick: handleTableClick,
  }

  const reloadTable = () => {
    window.$('table').DataTable().ajax.reload(null, false)
  }

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.entityType !== 'Flow') return
      if (e.detail?.section && e.detail.section !== section) return
      reloadTable()
    }
    window.addEventListener('bookmarks-changed', handler)
    return () => window.removeEventListener('bookmarks-changed', handler)
  }, [section])

  return (
    <div className="section">
      <PinnedBookmarks entityType="Flow" section={section} />

      <div className="box">
        <div className="header">
          <h2>Your {ballots ? 'ballots' : 'pages'}</h2>
        </div>

        <Table {...tableProps} />
      </div>
    </div>
  )
}

export default FlowsDatatable
